import type { ReactNode } from "react";

import { cx } from "class-variance-authority";

import { ChartSwatch } from "../ChartSwatch";
import * as tooltipTheme from "../Tooltip/Tooltip.css";

import * as theme from "./TrendChart.css";
import { TrendChartBucket, TrendChartSeries } from "./types";

export interface TrendChartTooltipProps {
    series: TrendChartSeries[];
    renderContent?: (
        bucket: TrendChartBucket,
        series: TrendChartSeries[]
    ) => ReactNode;
    // Supplied by recharts when it clones this element.
    active?: boolean;
    label?: string | number;
    payload?: Array<{ dataKey?: string | number; value?: number }>;
}

export function TrendChartTooltip({
    series,
    renderContent,
    active,
    label,
    payload,
}: TrendChartTooltipProps) {
    if (active !== true || payload === undefined || payload.length === 0) {
        return null;
    }

    const bucket: TrendChartBucket = {
        label: String(label ?? ""),
        values: Object.fromEntries(
            payload.map((entry) => [String(entry.dataKey), entry.value ?? 0])
        ),
    };

    if (renderContent !== undefined) {
        return <>{renderContent(bucket, series)}</>;
    }

    return (
        <div className={cx(tooltipTheme.content, theme.tooltip)}>
            <ul className={theme.tooltipList}>
                {series.map((entry) => (
                    <li key={entry.key} className={theme.tooltipRow}>
                        <ChartSwatch color={entry.color} ringed />
                        <span>{entry.label}</span>
                        <span className={theme.tooltipValue}>
                            {bucket.values[entry.key] ?? 0}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
}
